define('core/utils/lang/isFunction',[],function () {
    'use strict';

    // NOTE: Approach adapted from underscore 1.8.3
    return function isFunction(obj) {
        return Object.prototype.toString.call(obj) === '[object Function]';
    };
});

